<template>
    <div class="empty-state">
        <div class="empty-state-icon">{{ icon }}</div>

        <div class="empty-state-title">
            {{ title }}
        </div>

        <div v-if="message" class="empty-state-message">
            {{ message }}
        </div>

        <button
            v-if="buttonText"
            class="empty-state-button"
            type="button"
            @click="$emit('action')"
        >
            {{ buttonText }}
        </button>
    </div>
</template>

<script setup>
defineProps({
    icon: {
        type: String,
        default: '📭'
    },
    title: {
        type: String,
        default: 'Nenhum registro encontrado'
    },
    message: {
        type: String,
        default: ''
    },
    buttonText: {
        type: String,
        default: ''
    }
});

defineEmits(['action']);
</script>